import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as levenshtein from 'fast-levenshtein';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-districtandtalukawise-representative',
  
  templateUrl: './districtandtalukawise-representative.component.html',
  styleUrl: './districtandtalukawise-representative.component.scss'
})
export class DistrictandtalukawiseRepresentativeComponent{

     datewisedata;
     today = new Date();
     startdate = '';
     enddate = '';
     datewiselist = [];
     tempdata = [];
     district: any;
     taluka:any;
   
     isLoading: boolean = false;
     subTypesName = [
       { name: 'वार्षिक', isVisible: false },
       { name: 'त्रैवार्षिक', isVisible: false },
       { name: 'पंचवार्षिक', isVisible: false },
      
     ];
     totalth = 0;
     finalData = [];
     state: any;
     country: any;
  startDate: any;
  endDate: any;
  appliedFilters: any = {}; 
   
     constructor(
       private dialogref: MatDialogRef<DistrictandtalukawiseRepresentativeComponent>,
       @Inject(MAT_DIALOG_DATA) public data: any
     ) { }
   
     ngOnInit(): void {
       debugger
       this.isLoading = true;
       this.district = this.data.district
       this.taluka = this.data.taluka
       this.datewisedata = this.data['data'];
       console.log(this.datewisedata, "first data")
      
      //  const talukaWiseData = this.datewisedata.reduce((acc: any, item: any) => {
      //   if (!acc[item.rep_taluka]) {
      //     acc[item.rep_taluka] = [];
      //   }
      //   acc[item.rep_taluka].push(item);
      //   return acc;
      // }, {});
   
       console.log(this.datewisedata, "statewise")
       this.startDate = this.data['startDate'];
       this.endDate = this.data['endDate'];

       this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);
     
       let data = this.uniqueData(this.datewisedata, (a) => a.subscription_type);
   
       for (let i = 0; i < Object.keys(data).length; i++) {
         let flag = false;
         for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
           if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
             this.subTypesName[j]['isVisible'] = true;
             flag = true;
             break;
           }
         }
         if (!flag) {
           // if (
           //   data[i]['Subscription_Type'] !== 'हितचिंतक सप्रेम भेट' ||
           //   data[i]['Subscription_Type'] !== 'सप्रेम भेट - संपादकीय विभाग' ||
           //   data[i]['Subscription_Type'] !== 'जाहिरात स. भेट' ||
           //   data[i]['Subscription_Type'] !== 'संघ परिवार सप्रेम भेट' ||
           //   data[i]['Subscription_Type'] !== 'वर्गणी सप्रेम भेट'
           // ) {
           this.subTypesName.push({
             name: data[i]['subscription_type'],
             isVisible: true,
           });
           // }
         }
       }
   
       // console.log(this.subTypesName);
      //  this.totalth = this.subTypesName.length * 3 + 4;
       this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 6;
       // this.getDateORrepwiselist();
       this.setData();
     }
   
     gettalukaTotal(talukaData: any[], key: string): number {
       return talukaData.reduce((sum, office) => sum + (office[key] || 0), 0);
     }
   
     gettalukaSubtypeTotal( talukaData: any[], subName: string, suffix: string): number {
       return  talukaData.reduce((sum, office) => sum + (office.subtype_totals?.[this.getKey(subName) + suffix] || 0), 0);
     }
   
     getTotal(data: any[], key: string): number {
       return data.reduce((sum, country) =>
         sum + country.datewiseData.reduce((s, state) =>
           s + state.datewiseData.reduce((dSum, taluka) =>
             dSum + taluka.datewiseData.reduce((oSum, office) => oSum + (office[key] || 0), 0), 0), 0), 0);
     }
   
     getTotalSubtype(data: any[], subName: string, suffix: string): number {
       return data.reduce((sum, country) =>
         sum + country.datewiseData.reduce((s, state) =>
           s + state.datewiseData.reduce((dSum, taluka) =>
             dSum + taluka.datewiseData.reduce((oSum, office) =>
               oSum + (office.subtype_totals?.[this.getKey(subName) + suffix] || 0), 0), 0), 0), 0);
     }
   
     soundex(s: string): string {
       return s
         .toUpperCase()
         .replace(/[^A-Z]/g, "") // Remove non-alphabet characters
         .split("")
         .map((char) => {
           if ("AEIOUHWY".includes(char)) return "0";
           if ("BFPV".includes(char)) return "1";
           if ("CGJKQSXZ".includes(char)) return "2";
           if ("DT".includes(char)) return "3";
           if ("L".includes(char)) return "4";
           if ("MN".includes(char)) return "5";
           if ("R".includes(char)) return "6";
           return char;
         })
         .join("")
         .replace(/0/g, "");
     }
 
 

// setData() {
//   const nested: any = this.datewisedata.reduce((acc, r) => {
//     const { country, state, district_name: d, taluka: t } = r;

//     acc[country] ??= {};
//     acc[country][state] ??= {};
//     acc[country][state][d] ??= {};
//     acc[country][state][d][t] ??= [];
//     acc[country][state][d][t].push(r);

//     return acc;
//   }, {});

//   // Initialize global totals
//   const finalTot: any = {};
//   this.subTypesName.filter(b => b.isVisible).forEach((b, i) => {
//     const k = this.getKey(b.name);
//     finalTot[`${k}_एकूण`] = 0;
//     finalTot[`${k}_नवीन`] = 0;
//     finalTot[`${k}_नूतनीकरण`] = 0;
//     if (i === 0) {
//       finalTot['एकूण'] = 0;
//       finalTot['नवीन'] = 0;
//       finalTot['नूतनीकरण'] = 0;
//     }
//   });

//   // Traverse hierarchy
//   Object.entries(nested).forEach(([cKey, states]: any) => {
//     Object.entries(states).forEach(([sKey, districts]: any) => {
//       Object.entries(districts).forEach(([dKey, talukas]: any) => {
//         const updatedTalukaMap: any = {};

//         Object.entries(talukas).forEach(([tKey, recs]: any) => {
//           const repMap: { [rep: string]: any } = {};
//           const talukaAgg: any = {};

//           // Init taluka totals
//           this.subTypesName.filter(b => b.isVisible).forEach((b, i) => {
//             const k = this.getKey(b.name);
//             talukaAgg[`${k}_एकूण`] = 0;
//             talukaAgg[`${k}_नवीन`] = 0;
//             talukaAgg[`${k}_नूतनीकरण`] = 0;
//             if (i === 0) {
//               talukaAgg['एकूण'] = 0;
//               talukaAgg['नवीन'] = 0;
//               talukaAgg['नूतनीकरण'] = 0;
//             }
//           });

//           // Process records
//           recs.forEach(a => {
//             const subKey = this.getKey(a.subscription_type);
//             const repName = a.rep_name || 'Unknown';
//             const matchedKey = Object.keys(repMap).find(k => levenshtein.get(k, repName) <= 2) || repName;

//             if (!repMap[matchedKey]) {
//               const base = {
//                 total_amt: 0,
//                 new_count: 0,
//                 renew_count: 0
//               };
//               this.subTypesName.filter(b => b.isVisible).forEach(b => {
//                 const k = this.getKey(b.name);
//                 base[`${k}_एकूण`] = 0;
//                 base[`${k}_नवीन`] = 0;
//                 base[`${k}_नूतनीकरण`] = 0;
//               });
//               repMap[matchedKey] = base;
//             }

//             const rep = repMap[matchedKey];
//             const amt = +a.total_amt;
//             const isNew = a.rcpt_type === 'New';
//             const isRen = a.rcpt_type === 'Renew';

//             // Update rep
//             rep.total_amt += amt;
//             rep.new_count += isNew ? 1 : 0;
//             rep.renew_count += isRen ? 1 : 0;
//             rep[`${subKey}_एकूण`] += amt;
//             rep[`${subKey}_नवीन`] += isNew ? 1 : 0;
//             rep[`${subKey}_नूतनीकरण`] += isRen ? 1 : 0;

//             // Taluka
//             talukaAgg[`${subKey}_एकूण`] += amt;
//             talukaAgg[`${subKey}_नवीन`] += isNew ? 1 : 0;
//             talukaAgg[`${subKey}_नूतनीकरण`] += isRen ? 1 : 0;
//             talukaAgg['एकूण'] += amt;
//             talukaAgg['नवीन'] += isNew ? 1 : 0;
//             talukaAgg['नूतनीकरण'] += isRen ? 1 : 0;

//             // Global
//             finalTot[`${subKey}_एकूण`] += amt;
//             finalTot[`${subKey}_नवीन`] += isNew ? 1 : 0;
//             finalTot[`${subKey}_नूतनीकरण`] += isRen ? 1 : 0;
//             finalTot['एकूण'] += amt;
//             finalTot['नवीन'] += isNew ? 1 : 0;
//             finalTot['नूतनीकरण'] += isRen ? 1 : 0;
//           });

//           updatedTalukaMap[tKey] = {
//             records: recs,
//             finalData: talukaAgg,
//             representatives: repMap // <== keep as object (not Map)
//           };
//         });

//         nested[cKey][sKey][dKey] = updatedTalukaMap;
//       });
//     });
//   });

//   // Final output
//   this.finalData = [
//     ...Object.entries(nested).map(([key, value]) => ({ key, value })),
//     { key: 'finalData', value: finalTot }
//   ];

//   this.isLoading = false;
// }


setData() {
  const nested: any = this.datewisedata.reduce((acc, r) => {
    const { country, state, district_name: d, taluka: t } = r;

    acc[country] ??= {};
    acc[country][state] ??= {};
    acc[country][state][d] ??= {};
    acc[country][state][d][t] ??= [];
    acc[country][state][d][t].push(r);

    return acc;
  }, {});

  // Initialize global totals
  const finalTot: any = {};
  this.subTypesName.filter(b => b.isVisible).forEach((b, i) => {
    const k = this.getKey(b.name);
    finalTot[`${k}_एकूण`] = 0;
    finalTot[`${k}_नवीन`] = 0;
    finalTot[`${k}_नूतनीकरण`] = 0;
    if (i === 0) {
      finalTot['एकूण'] = 0;
      finalTot['नवीन'] = 0;
      finalTot['नूतनीकरण'] = 0;
    }
  });

  // Traverse hierarchy
  Object.entries(nested).forEach(([cKey, states]: any) => {
    Object.entries(states).forEach(([sKey, districts]: any) => {
      Object.entries(districts).forEach(([dKey, talukas]: any) => {
        const updatedTalukaMap: any = {};
        const districtAgg: any = {};

        // init district totals
        this.subTypesName.filter(b => b.isVisible).forEach((b, i) => {
          const k = this.getKey(b.name);
          districtAgg[`${k}_एकूण`] = 0;
          districtAgg[`${k}_नवीन`] = 0;
          districtAgg[`${k}_नूतनीकरण`] = 0;
          if (i === 0) {
            districtAgg['एकूण'] = 0;
            districtAgg['नवीन'] = 0;
            districtAgg['नूतनीकरण'] = 0;
          }
        });

        Object.entries(talukas).forEach(([tKey, recs]: any) => {
          const repMap: { [rep: string]: any } = {};
          const talukaAgg: any = {};

          // Init taluka totals
          this.subTypesName.filter(b => b.isVisible).forEach((b, i) => {
            const k = this.getKey(b.name);
            talukaAgg[`${k}_एकूण`] = 0;
            talukaAgg[`${k}_नवीन`] = 0;
            talukaAgg[`${k}_नूतनीकरण`] = 0;
            if (i === 0) {
              talukaAgg['एकूण'] = 0;
              talukaAgg['नवीन'] = 0;
              talukaAgg['नूतनीकरण'] = 0;
            }
          });

          recs.forEach(a => {
            const subKey = this.getKey(a.subscription_type);
            const repName = a.rep_name || 'Unknown';
            const repTaluka = a.rep_taluka || 'Unknown Taluka';
            const matchedKey =
              Object.keys(repMap).find(k => levenshtein.get(k, repName) <= 2) || repName;

            if (!repMap[matchedKey]) {
              const base = {
                rep_taluka: repTaluka,
                total_amt: 0,
                new_count: 0,
                renew_count: 0
              };
              this.subTypesName.filter(b => b.isVisible).forEach(b => {
                const k = this.getKey(b.name);
                base[`${k}_एकूण`] = 0;
                base[`${k}_नवीन`] = 0;
                base[`${k}_नूतनीकरण`] = 0;
              });
              repMap[matchedKey] = base;
            }

            const rep = repMap[matchedKey];
            const amt = +a.total_amt;
            const isNew = a.rcpt_type === 'New';
            const isRen = a.rcpt_type === 'Renew';

            // Update rep
            rep.total_amt += amt;
            rep.new_count += isNew ? 1 : 0;
            rep.renew_count += isRen ? 1 : 0;
            rep[`${subKey}_एकूण`] += amt;
            rep[`${subKey}_नवीन`] += isNew ? 1 : 0;
            rep[`${subKey}_नूतनीकरण`] += isRen ? 1 : 0;

            // Taluka
            talukaAgg[`${subKey}_एकूण`] += amt;
            talukaAgg[`${subKey}_नवीन`] += isNew ? 1 : 0;
            talukaAgg[`${subKey}_नूतनीकरण`] += isRen ? 1 : 0;
            talukaAgg['एकूण'] += amt;
            talukaAgg['नवीन'] += isNew ? 1 : 0;
            talukaAgg['नूतनीकरण'] += isRen ? 1 : 0;

            // District
            districtAgg[`${subKey}_एकूण`] += amt;
            districtAgg[`${subKey}_नवीन`] += isNew ? 1 : 0;
            districtAgg[`${subKey}_नूतनीकरण`] += isRen ? 1 : 0;
            districtAgg['एकूण'] += amt;
            districtAgg['नवीन'] += isNew ? 1 : 0;
            districtAgg['नूतनीकरण'] += isRen ? 1 : 0;

            // Global
            finalTot[`${subKey}_एकूण`] += amt;
            finalTot[`${subKey}_नवीन`] += isNew ? 1 : 0;
            finalTot[`${subKey}_नूतनीकरण`] += isRen ? 1 : 0;
            finalTot['एकूण'] += amt;
            finalTot['नवीन'] += isNew ? 1 : 0;
            finalTot['नूतनीकरण'] += isRen ? 1 : 0;
          });

          updatedTalukaMap[tKey] = {
            records: recs,
            finalData: talukaAgg,
            representatives: repMap
          };
        });

        // attach district totals
        nested[cKey][sKey][dKey] = {
          talukas: updatedTalukaMap,
          finalData: districtAgg
        };
      });
    });
  });

  // Final output
  this.finalData = [
    ...Object.entries(nested).map(([key, value]) => ({ key, value })),
    { key: 'finalData', value: finalTot }
  ];

  this.isLoading = false;
}

   
   
     getKey(name) {
       return name.replaceAll(' ', '_');
     }
   
     uniqueData(data, key) {
       return [...new Map(data.map((a) => [key(a), a])).values()];
     }
      exportExcel(fileName) {
         /* table id is passed over here */
         let element = document.getElementById('print-section1');
         const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
     
         /* generate workbook and add the worksheet */
         const wb: XLSX.WorkBook = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
     
         /* save to file */
         XLSX.writeFile(wb, fileName + '.xlsx');
       }
       show = false
       printPage() {
        this.show = true;
      
        const printContent = document.getElementById('print-section1')?.innerHTML;
        if (!printContent) {
          console.error("Print section not found!");
          return;
        }
      
        const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
      
        if (printWindow) {
          printWindow.document.open();
          printWindow.document.write(`
            <html>
              <head>
                <title>Print Report</title>
                <style>
                  @media print {
                    @page {
                      size: A3 landscape;
                      margin: 10mm;
                    }
      
                    body {
                      font-family: Arial, sans-serif;
                      font-size: 13px;
                      margin: 0;
                      padding: 0;
                    }
      
                    table {
                      width: 100%;
                      border-collapse: collapse;
                      page-break-inside: avoid;
                    }
      
                    th, td {
                      border: 1px solid black;
                      padding: 3px 5px;
                      font-size: 14px;
                      
                    }
      
                    tr {
                      page-break-inside: avoid;
                      page-break-after: auto;
                    }
      
                    .noPrint {
                      display: none;
                    }
                  }
      
                  body {
                    font-family: Arial, sans-serif;
                    font-size: 13px;
                  }
      
                  table {
                    width: 100%;
                    border-collapse: collapse;
                  }
      
                  th, td {
                    border: 1px solid black;
                    padding: 3px 5px;
                    text-align: center;
                  }
                </style>
              </head>
              <body>
                <div>
                  ${printContent}
                </div>
                <script>
                  window.onload = function() {
                    window.print();
                    setTimeout(() => { window.close(); }, 500);
                  };
                </script>
              </body>
            </html>
          `);
          printWindow.document.close();
        } else {
          console.error("Failed to open print window.");
        }
      }
   
    }